import { messagesBallons } from './array';

import * as S from './styles';

const ChatMessageLoadingSkeleton: React.FC = () => {
  const messages = messagesBallons;
  return (
    <S.Container data-testid="skeleton-loading">
      {messages.map(message => (
        <S.ContainerMessageBalloon
          key={message.id}
          alignMessage={message.justifyContent}
        >
          <S.MessageBalloon style={message} />
        </S.ContainerMessageBalloon>
      ))}
    </S.Container>
  );
};

export default ChatMessageLoadingSkeleton;
